import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {Tabs} from '@chakra-ui/react'

export function HistoryTab() {
  const {activities} = useSolutionDrugContext()

  return (
    <Tabs.Content value="history">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
